/*!

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)
* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import './reports.css';
import React from "react";
import { Button, Input, InputGroup, InputGroupText, Table, Row, Col } from "reactstrap";


class Reports extends React.Component {

	constructor(props) {
		super(props);

		// const urlReport = 'https://timecards.shinydata.com/report.php?s=datrix%20-%20&quarters&sinceWhen=may%201,%202020';

		this.state = {
			isAuthorized: localStorage.getItem('isAuthorized'),
			sinceWhen: "", // "midnight this week",
			forWhat: "Datrix",
			password: '',
			allRows: [],
			total: 0,
		}

		// localStorage.removeItem('isAuthorized');	// requires new authentication for the protected areas

		this.handleAuthorizationPassword = this.handleAuthorizationPassword.bind(this);
		this.handleGetReport = this.handleGetReport.bind(this);
		this.handleSinceWhen = this.handleSinceWhen.bind(this);
		this.handleForWhat = this.handleForWhat.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.getReport = this.getReport.bind(this);
	}

	componentDidMount() {
		this.getReport();
	}

	handleAuthorizationPassword( event ) {
		event.preventDefault();

		if ( this.state.password === '00' ) {
			this.setState( { isAuthorized: true } );
			localStorage.setItem('isAuthorized', true );
		}
	}

	setPassword(val) {
		this.setState( { password: val } );
	}


	loginFirst() {
		return (
			<div className="Login">
			  <form onSubmit={this.handleAuthorizationPassword}>
				<InputGroup name="password">
				  <InputGroupText> Unlock Code </InputGroupText>
				  <Input
					value={this.state.password}
					onChange={e => this.setPassword(e.target.value)}
				  />
				</InputGroup>
				<Button block type="submit">
				  Login
				</Button>
			  </form>
			</div>
		);

	}

	handleSinceWhen(str) {
		this.setState({ sinceWhen: str });
	}

	handleForWhat(str) {
		this.setState({ forWhat: str });
	}

	handleGetReport() {
		this.getReport();
	}

	handleKeyDown(e) {
        if (e.key === 'Enter') {
			this.handleGetReport();
        }
	}


	reportInputs() {
		return (
		<>
			<Table className="field" >

				<Row className="">
					<Col className="label">
					Since When:
					</Col>

					<Col >
					<Input
						value={this.state.sinceWhen}
						onChange={e => this.handleSinceWhen(e.target.value)}
						onKeyDown={this.handleKeyDown} 
					/>
					</Col>
				</Row>

				<Row className="">
					<Col className="label">
					For What:
					</Col>

					<Col >
					<Input
						value={this.state.forWhat}
						onChange={e => this.handleForWhat(e.target.value)}
						onKeyDown={this.handleKeyDown} 
					/>
					</Col>

				</Row>

			</Table>

				<Row className="centerButton">
					<Col >

					<Button
						className="btn-round"
						color="success"
						outline
						size="sm"
						onClick={this.handleGetReport}
					>
						Get Report
					</Button>

					</Col>

				</Row>
		</>
		);
	}

	getReport() {
		// const url = `https://timecards.shinydata.com/report.php?s=${this.state.forWhat}&json&quarters&sinceWhen=${this.state.sinceWhen}`;
		const url = `https://timecards.shinydata.com/report.php?s=${this.state.forWhat}&json&sinceWhen=${this.state.sinceWhen}`;

		console.log("url: " + url );

		fetch(url)
			.then(function (response) {
				// console.log(url + " -> " + response.ok);
				return response.json();
			})
			.then(function (data) {
				// console.log("data: "); console.dir(data);
				this.setState({ allRows: data.all, total: data.total });
			}.bind(this))
			.catch(function (err) {
				console.log("failed to load ", url, err.stack);
			});
	}


	reportOutput(allRows) {
		const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

		return (
			<div>
			<Table>
				{allRows.map((row, idx) => (
					<Row>
						<Col lg="3">
							{row.project}
						</Col>
						<Col lg="1">
							{parseFloat(row.sum).toFixed(3)}
						</Col>
						<Col lg="1">
							{row.theDate}
						</Col>
						<Col lg="1">
							{ weekday[new Date(row.theDate + ' 8:00').getDay()] }
						</Col>

					</Row>
				))}

			</Table>
			</div>
		);
	}


	render() {

		if ( ! this.state.isAuthorized ) {
			return (
			<div className="content"
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}>
				{this.loginFirst()}
			</div>
			);
		}

		return (
		  <>
			<div className="content">

			<h5 className="title"> Reports </h5>

			{ this.reportInputs() }

			Total: <b> { this.state.total.toFixed(3) } </b>

			<br />
			<br />

			{ this.reportOutput(this.state.allRows) }


			</div>
		  </>
		);
	}
}

export default Reports;
